import { Component, Vue, Watch } from 'vue-property-decorator';
import WithRender from './App.html';
import './App.css';
import { Inject } from 'vue-di-container';
import MemoryService from '@/Services/MemoryService';

@WithRender
@Component({
    diProvide: [
        MemoryService
    ],
})
export default class App extends Vue {
    @Inject(MemoryService) public memoryService!: MemoryService;
    public breadcrumbList: any = [];

    public showBreadcrumb = true;

    public async mounted() {
        this.onRouteChange();
    }

    @Watch('$route')
    public onRouteChange(): any {
        if (this.$route.query.id && this.$route.query.id != '' && this.$route.query.key && this.$route.query.key != '') {
            this.showBreadcrumb = false;
        }
        else {
            this.showBreadcrumb = true;
            if (this.$route.meta && this.$route.meta.breadcrumb) {

                this.breadcrumbList = this.$route.meta.breadcrumb;
            }
        }
    }

    public routeTo(pRouteTo: number) {
        if (this.breadcrumbList[pRouteTo].link) {
            this.$router.push(this.breadcrumbList[pRouteTo].link);
        }
    }
}
